import Image from "next/image";
import { ImageStoryblok } from "@/types/sb-component-types";
import { getDimensionsFromFilename } from "@/lib/storyblok/get-dimensions";
interface SbImageProps {
  blok: ImageStoryblok;
}
export const SBImage = ({
  blok
}: SbImageProps) => {
  const {
    image
  } = blok;
  if (!image?.filename) return null;
  const dimensions = getDimensionsFromFilename(image?.filename);
  return <Image alt={image.alt ?? ""} className="my-12 rounded-sm" height={dimensions?.height ?? 0} src={image?.filename} width={dimensions?.width ?? 0} data-sentry-element="Image" data-sentry-component="SBImage" data-sentry-source-file="Image.tsx" />;
};